import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './App.css';
import { AppRouter } from './navigations';

const queryClient = new QueryClient();

function App() {

  return (
    <QueryClientProvider client={queryClient}>
      <AppRouter />
    </QueryClientProvider>
  );
}

export default App;
